import { getLocalApi } from "./localApi";
import { TransferPort} from "app/shared/model";
import apiConfig from "app/api/apiConfig.json";

export async function getAllTransferPorts() : Promise<TransferPort[]> {
    const localApi = await getLocalApi();

    return await localApi.fetchList(apiConfig.reference_data_get_transfer_ports, (dto:any) => ({
        name: dto.name,
        id: dto.id
    }), 'Unable to fetch transfer ports')
}